import { listWidgetKinds } from "@/widgets/registry";
import { Modal } from "./Modal";

interface Props {
  open: boolean;
  scope: "day" | "week";
  onClose: () => void;
  onPick: (kind: string) => void;
}

export function WidgetPicker({ open, scope, onClose, onPick }: Props) {
  const kinds = listWidgetKinds(scope);
  return (
    <Modal open={open} onClose={onClose} data-testid="widget-picker">
      <h2>Velg widget</h2>
      {kinds.length === 0 ? (
        <p data-testid="widget-picker-empty">
          Ingen widget-typer i dette omfanget.
        </p>
      ) : (
        <ul className="option-list">
          {kinds.map((k) => (
            <li key={k.kind}>
              <button
                type="button"
                className="option"
                onClick={() => onPick(k.kind)}
                data-testid={`widget-pick-${k.kind}`}
              >
                {k.label}
              </button>
            </li>
          ))}
        </ul>
      )}
      <div className="modal-actions">
        <button
          type="button"
          className="btn ghost"
          onClick={onClose}
          data-testid="widget-picker-cancel"
        >
          Avbryt
        </button>
      </div>
    </Modal>
  );
}
